import { MutationTree } from 'vuex';
import { MenusState } from "./types";

export const mutations: MutationTree<MenusState> = { 

    setTest(state, payload: string) {
        state.test = payload
    },
    setCurrentSidebarElement(state, payload : string){
        state.currentSidebarElement = payload
    }
}